class CustomInstructionsServiceImpl {
    constructor(options) {
        this.options = options;
        this.listeners = new Set();
    }
    getAdapter() {
        return this.options.adapterFactory();
    }
    log(message, payload) {
        if (!this.options.loggerPrefix) {
            return;
        }
        if (payload !== undefined) {
            console.log(`${this.options.loggerPrefix} ${message}`, payload);
        }
        else {
            console.log(`${this.options.loggerPrefix} ${message}`);
        }
    }
    getInstructions(category = this.options.defaultCategory) {
        return this.getAdapter().getInstructions(category);
    }
    getActiveInstructions(category = this.options.defaultCategory) {
        return this.getAdapter().getActiveInstructions(category);
    }
    getActiveInstructionsText(category = this.options.defaultCategory) {
        return this.getAdapter().getActiveInstructionsText(category);
    }
    getInstructionById(id, category = this.options.defaultCategory) {
        return this.getInstructions(category).find((instruction) => instruction.id === id);
    }
    async addInstruction(instruction, category = this.options.defaultCategory) {
        const created = await this.getAdapter().addInstruction(category, instruction);
        this.notifyListeners(category);
        this.log("Added instruction", { category, id: created.id, title: created.title });
        return created;
    }
    async updateInstruction(id, updates, category = this.options.defaultCategory) {
        await this.getAdapter().updateInstruction(category, id, updates);
        this.notifyListeners(category);
        this.log("Updated instruction", { category, id });
    }
    async deleteInstruction(id, category = this.options.defaultCategory) {
        await this.getAdapter().deleteInstruction(category, id);
        this.notifyListeners(category);
        this.log("Deleted instruction", { category, id });
    }
    async toggleInstruction(id, category = this.options.defaultCategory) {
        await this.getAdapter().toggleInstruction(category, id);
        this.notifyListeners(category);
        this.log("Toggled instruction", { category, id });
    }
    async setInstructions(instructions, category = this.options.defaultCategory) {
        await this.getAdapter().setInstructions(category, instructions);
        this.notifyListeners(category);
        this.log("Set all instructions", { category, count: instructions.length });
    }
    subscribe(listener, _category = this.options.defaultCategory) {
        void _category;
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notifyListeners(category) {
        const currentInstructions = this.getInstructions(category);
        this.listeners.forEach((listener) => {
            try {
                listener(currentInstructions);
            }
            catch (error) {
                console.error("[CustomInstructionsService] Listener error:", error);
            }
        });
    }
}
export function createCustomInstructionsService(options) {
    return new CustomInstructionsServiceImpl(options);
}
